import React, { useState } from 'react';
import { Card } from '../ui/card';
import { Separator } from '../ui/separator';
import { User, Bot, Code, Settings } from 'lucide-react';
import TurnDetailsTechnical from './TurnDetailsTechnical';
import RatingControl from './RatingControl';

const getFirstNodeState = (nodes) => { if (!nodes || nodes.length === 0) return null; try { return JSON.parse(nodes[0].writes_json); } catch { return null; } };
const getActualUserMessage = (nodes) => { if (!nodes || nodes.length === 0) return null; try { const state = JSON.parse(nodes[0].writes_json); const msgs = (state.messages || []).filter((m) => m.type === 'human'); return msgs.length > 0 ? msgs[msgs.length - 1].content : null; } catch { return null; } };

const TurnCard = ({ turnIndex, turn, evaluation, onEvaluationSave }) => {
  const [showTechnical, setShowTechnical] = useState(false);
  const firstNodeState = getFirstNodeState(turn.nodes);
  const isSystemMessage = firstNodeState?.system_message_received === true;
  const systemInstructions = firstNodeState?.system_message_instructions;
  const displayQuery = getActualUserMessage(turn.nodes) || turn.query;

  return (
    <Card className="mb-3 overflow-hidden transition-all hover:border-white/20">
      <div className="p-3 bg-white/[0.02] flex justify-between items-center">
        <span className="text-sm font-bold text-primary-500">Turn #{turnIndex + 1}</span>
        <button onClick={() => setShowTechnical(!showTechnical)} className="flex items-center gap-1 px-2 py-1 text-xs rounded-md border border-white/10 text-ink-dim hover:bg-surface-2 hover:text-ink transition-colors">
          <Code className="h-3.5 w-3.5" />Technical
        </button>
      </div>
      <div className="p-4 pb-2">
        {isSystemMessage ? (
          <>
            <div className="flex items-center gap-1.5 mb-1"><Settings className="h-4 w-4 text-brand-yellow" /><span className="text-xs font-bold text-brand-yellow">System Message</span></div>
            <div className="p-3 bg-brand-yellow/5 border-l-4 border-brand-yellow rounded-r-md"><p className="text-sm">{systemInstructions || 'No system instructions'}</p></div>
          </>
        ) : (
          <>
            <div className="flex items-center gap-1.5 mb-1"><User className="h-4 w-4 text-ink-dim" /><span className="text-xs font-bold text-ink-dim">User Query</span></div>
            <div className="p-3 bg-brand-blue/5 border-l-4 border-brand-blue rounded-r-md"><p className="text-sm">{displayQuery || 'No query'}</p></div>
          </>
        )}
      </div>
      <div className="px-4 pb-2">
        <div className="flex items-center gap-1.5 mb-1"><Bot className="h-4 w-4 text-brand-green" /><span className="text-xs font-bold text-ink-dim">Bot Response</span></div>
        <div className="p-3 bg-brand-green/5 border-l-4 border-brand-green rounded-r-md"><p className="text-sm">{turn.final_answer}</p></div>
      </div>
      <div className="p-4 pt-2"><RatingControl turnIndex={turnIndex} evaluation={evaluation} onSave={async (data) => { await onEvaluationSave(turnIndex, data); }} /></div>
      {showTechnical && <><Separator /><div className="p-4"><TurnDetailsTechnical turn={turn} /></div></>}
    </Card>
  );
};

export default TurnCard;
